"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function queryString(query) {
    var queryStringParamEncode = function (k) { return encodeURIComponent(k) + "=" + encodeURIComponent(query[k]); };
    return query && Object.keys(query).map(queryStringParamEncode).join('&');
}
exports.queryString = queryString;
function getUrl(resource, query) {
    var qs = queryString(query);
    return qs ? resource + "?" + qs : resource;
}
exports.getUrl = getUrl;
//# sourceMappingURL=Urls.js.map